import React from "react";
import Integrations from "../modules/Integrations";

export function IntegrationsPage() {
  return <Integrations />;
}
